export enum SocialPlatformEnum {
  Google = 'google',
}
